<template>
  <div id="bd-message" v-paste="pasteImage" v-drag="dragPasteImage">
    <!-- TODO: 背景右键：支持多选，清空聊天记录(当前会话为空的情况下) -->
    <!-- v-infinite-scroll="loadMoreMessage" infinite-scroll-disabled="loadDisabled" -->
    <div v-if="isTicketThread">
      <h3>{{ userCurrentTicket.title }}</h3>
      <span v-html="userCurrentTicket.content"></span>
    </div>
    <el-empty
      v-if="protobufMessages.length === 0"
      :description="haveNoDataTip"
    ></el-empty>
    <ul v-if="!disabled" class="bd-message-ul" ref="list">
      <div
        v-if="!userCurrentThreadMore.last && !showLoading"
        class="pullrefresh"
        @click="getMoreMessages()"
      >
        {{ $t("moreMessage") }}
      </div>
      <div v-if="showLoading" class="pullrefresh">
        <i class="el-icon-loading" /><span>{{ this.$t("loadingData") }}</span>
      </div>
      <li
        v-for="message in protobufMessages"
        :key="message.mid"
        :id="message.mid"
      >
        <p class="timestamp">
          <span>{{ message.createdAt | datetime }}</span
          ><br />
          <span v-if="is_type_notification_agent_close(message)">{{
            agentCloseThreadTip
          }}</span>
          <span v-else-if="is_type_notification_visitor_close(message)">{{
            visitorCloseThreadTip
          }}</span>
          <span v-else-if="is_type_notification_auto_close(message)">{{
            autoCloseThreadTip
          }}</span>
          <span v-else-if="is_type_notification_thread_reentry(message)">{{
            threadReentryTip
          }}</span>
          <span v-else-if="is_type_notification_connect(message)">{{
            visitorConnectTip
          }}</span>
          <span v-else-if="is_type_notification_disconnect(message)">{{
            visitorDisconnectTip
          }}</span>
          <span v-else-if="is_type_notification_offline(message)">{{
            agentOfflineTip
          }}</span>
          <span v-else-if="is_type_notification_invite_rate(message)">{{
            inviteRateTip
          }}</span>
          <span v-else-if="is_type_notification_rate_result(message)">{{
            rateResultTip
          }}</span>
          <span v-else-if="is_type_notification_invite_video(message)">{{
            inviteVideoThreadTip
          }}</span>
          <span v-else-if="is_type_notification_invite_audio(message)">{{
            inviteAudioThreadTip
          }}</span>
          <span v-else-if="is_type_notification_queue(message)">{{
            message.content
          }}</span>
          <span v-else-if="is_type_notification_queue_accept(message)">{{
            joinQueueThreadTip
          }}</span>
          <span v-else-if="is_type_notification(message)">{{
            message.content
          }}</span>
        </p>

        <div
          v-if="!is_type_notification(message)"
          class="main"
          :class="{ self: is_self(message) }"
        >
          <el-image
            v-if="show_header"
            class="avatar"
            style="width: 30px; height: 30px;"
            :src="message.user.avatar"
            :preview-src-list="[message.user.avatar]"
          />
          <div
            v-if="!is_self(message)"
            class="nickname"
            @click="nicknameClicked(message.user.nickname)"
          >
            {{ message.user.nickname }}{{ fromClient(message) }}
          </div>
          <!-- TODO: 支持发送格式化内容，如可换行 -->
          <div
            v-if="is_type_text(message)"
            class="text"
            v-html="replaceFace(message.content)"
            @click="textClicked(message)"
            @click.right="rightEvent(message)"
            @contextmenu.prevent="onContextmenu"
          ></div>
          <div v-else-if="is_type_robot(message)" class="text">
            <span v-html="message.content"></span>
            <span v-for="answer in message.answers" :key="answer.id">
              <br /><span style="color:#007bff; cursor: pointer;">{{
                answer.question
              }}</span>
            </span>
          </div>
          <div v-else-if="is_type_robotv2(message)" class="text">
            <span v-html="message.content"></span>
          </div>
          <div v-else-if="is_type_questionnaire(message)" class="text">
            <span>{{ message.questionnaire.questionnaireItems[0].title }}</span>
            <span
              v-for="item in message.questionnaire.questionnaireItems[0]
                .questionnaireItemItems"
              :key="item.id"
            >
              <br />
              <span style="color:#007bff; cursor: pointer;">{{
                item.content
              }}</span>
            </span>
          </div>
          <div v-else-if="is_type_company(message)" class="text">
            <span>{{ message.content }}</span>
            <span v-for="item in message.company.countries" :key="item.cid">
              <br />
              <span style="color:#007bff; cursor: pointer;">{{
                item.name
              }}</span>
            </span>
          </div>
          <div v-else-if="is_type_workGroup(message)" class="text">
            <span>{{ message.content }}</span>
            <span v-for="item in message.workGroups" :key="item.wid">
              <br />
              <span style="color:#007bff; cursor: pointer;">{{
                item.nickname
              }}</span>
            </span>
          </div>
          <div v-else-if="is_type_image(message)"
            class="text"
            @click.right="rightEvent(message)"
            @contextmenu.prevent="onImageContextmenu"
          >
            <image-message
              :src="message.imageUrl"
              style="padding-top: 10px; cursor: pointer;"
            />
          </div>
          <div v-else-if="is_type_file(message)"
            class="text"
            @click.right="rightEvent(message)"
            @contextmenu.prevent="onContextmenu"
          >
            <file-message
              :fileUrl="message.fileUrl"
              style="margin-top: 8px; margin-bottom: 10px; cursor: pointer;"
            />
          </div>
          <div v-else-if="is_type_voice(message)"
            class="text"
            @click.right="rightEvent(message)"
            @contextmenu.prevent="onContextmenu"
          >
            <!-- 音频文件 -->
            <audio-message
              :src="message.voiceUrl"
              style="margin-top: 8px; margin-bottom: 10px; cursor: pointer;"
            />
          </div>
          <div v-else-if="is_type_video(message)"
            class="text"
            @click.right="rightEvent(message)"
            @contextmenu.prevent="onContextmenu"
          >
            <!-- 视频文件预留 -->
            <video-message
              :src="message.videoOrShortUrl"
              style="margin-top: 8px; cursor: pointer;"
            />
          </div>
          <div v-else-if="is_type_card(message)"
            class="text"
            @click.right="rightEvent(message)"
            @contextmenu.prevent="onContextmenu"
          >
            <card-message
              :fileUrl="JSON.parse(message.content).content"
              style="margin-top: 8px; margin-bottom: 10px; cursor: pointer;"
            />
          </div>
          <!-- <div v-else-if="is_type_choice(message)" class="text">
            TODO: <span v-html="message.content"></span>
          </div> -->
          <div v-else-if="is_type_location(message)" class="text">
            {{ formatLocation(message) }}
          </div>
          <div v-else-if="is_type_event(message)" class="text">
            {{ formatEvent(message) }}
          </div>
          <!-- TODO: 以下类型有待格式化显示 -->
          <div v-else-if="is_type_link(message)" class="text">
            {{ message.title }}
          </div>
          <div v-else-if="is_type_custom(message)" class="text">
            {{ message.content }}
          </div>
          <!-- TODO: 工单消息, 待完善 -->
          <div v-else-if="is_type_ticket(message)" class="text">
            {{ message.content }}
          </div>
          <!-- TODO: 意见反馈, 待完善 -->
          <div v-else-if="is_type_feedback(message)" class="text">
            {{ message.content }}
          </div>
          <!-- TODO: 渠道消息, 待完善 -->
          <div v-else-if="is_type_channel(message)" class="text">
            <h5>{{ formatChannelTitle(message) }}</h5>
            <p>{{ formatChannelContent(message) }}</p>
          </div>
          <!-- TODO: 表单待完善 -->
          <!-- TODO: 多语言支持 -->
          <div v-else-if="is_type_form_request(message)" class="text">
            请求表单
          </div>
          <div v-else-if="is_type_form_result(message)" class="text">
            <div
              v-if="formObject(message.content).form.realname.trim().length > 0"
            >
              {{ $t("name") }}：{{ formObject(message.content).form.realname }}
            </div>
            <div
              v-if="formObject(message.content).form.mobile.trim().length > 0"
            >
              {{ $t("mobile") }}：{{ formObject(message.content).form.mobile }}
            </div>
            <div
              v-if="formObject(message.content).form.email.trim().length > 0"
            >
              {{ $t("email") }}：{{ formObject(message.content).form.email }}
            </div>
            <div v-if="formObject(message.content).form.age > 0">
              {{ $t("age") }}：{{ formObject(message.content).form.age }}
            </div>
            <div v-if="formObject(message.content).form.job.trim().length > 0">
              {{ $t("job") }}：{{ formObject(message.content).form.job }}
            </div>
          </div>
          <div v-else-if="is_type_red_packet(message)" class="text">
            {{ message.content }}
          </div>
          <div v-else-if="is_type_commodity(message)" class="text">
            <div>{{ $t("uuid") }}: {{ jsonObject(message.content).id }}</div>
            <div>
              {{ $t("categoryCode") }}:
              {{ jsonObject(message.content).categoryCode }}
            </div>
            <div>
              {{ $t("price") }}: {{ jsonObject(message.content).price }}
            </div>
            <div>
              {{ $t("title") }}: {{ jsonObject(message.content).title }}
            </div>
            <div>
              {{ $t("detail") }}: {{ jsonObject(message.content).content }}
            </div>
            <div>
              <a
                style="color:blue;"
                :href="jsonObject(message.content).url"
                target="_blank"
                >{{ $t("link") }}</a
              >
            </div>
            <div>
              <a
                style="color:blue;"
                :href="jsonObject(message.content).url"
                target="_blank"
              >
                <img
                  :src="jsonObject(message.content).imageUrl"
                  style="width: 50px; height:50px;"
                />
              </a>
            </div>
          </div>
          <div v-else-if="is_type_channels_shop_product(message)" class="text">
            <!-- /**
              * {
              * "msgtype" : "channels_shop_product",
              * "channels_shop_product" : {
              * "product_id": "PRODUCT_ID",
              * "head_image": "HEAD_IMAGE",
              * "title": "TITLE",
              * "sales_price": "SALES_PRICE",
              * "shop_nickname": "SHOP_NICKNAME",
              * "shop_head_image": "SHOP_HEAD_IMAGE"
              * }
              * }
              */ -->
            <!-- {{ message.content }} -->
            <div>{{ $t("uuid") }}: {{ jsonObject(message.content).product_id }}</div>
            <div>
              {{ $t("price") }}: {{ jsonObject(message.content).sales_price }}
            </div>
            <div>
              {{ $t("title") }}: {{ jsonObject(message.content).title }}
            </div>
            <div>
              {{ $t("shop_nickname") }}: {{ jsonObject(message.content).shop_nickname }}
            </div>
            <div>
              <a
                style="color:blue;"
                :href="jsonObject(message.content).head_image"
                target="_blank"
              >
                <img
                  :src="jsonObject(message.content).head_image"
                  style="width: 50px; height:50px;"
                />
              </a>
            </div>
          </div>
          <div v-else-if="is_type_channels_shop_order(message)" class="text">
            <!-- /**
              * {
              * "msgtype" : "channels_shop_order",
              * "channels_shop_order" : {
              * "order_id": "ORDER_ID",
              * "product_titles":"PRODUCT_TITLES",
              * "price_wording":"PRICE_WORDING",
              * "state":"STATE",
              * "image_url":"IMAGE_URL",
              * "shop_nickname":"SHOP_NICKNAME"
              * }
              * }
              */ -->
            <!-- {{ message.content }} -->
            <div>{{ $t("uuid") }}: {{ jsonObject(message.content).order_id }}</div>
            <div>
              {{ $t("price") }}: {{ jsonObject(message.content).price_wording }}
            </div>
            <div>
              {{ $t("title") }}: {{ jsonObject(message.content).product_titles }}
            </div>
            <div>
              {{ $t("state") }}: {{ jsonObject(message.content).state }}
              {{ $t("shop_nickname") }}: {{ jsonObject(message.content).shop_nickname }} 
            </div>
            <div>
              <a
                style="color:blue;"
                :href="jsonObject(message.content).image_url"
                target="_blank"
              >
                <img
                  :src="jsonObject(message.content).image_url"
                  style="width: 50px; height:50px;"
                />
              </a>
            </div>
          </div>
          <div v-else class="text">
            {{ $t("unknowMessageType") }}: {{ message.content }}
          </div>
          <!-- TODO: 发送超时左边显示error-icon，点击可重发 -->
          <div v-if="is_self(message)" class="status">
            <i
              v-if="is_sending(message)"
              class="el-icon-loading"
              style="font-size:10px"
            ></i>
            <i
              v-else-if="is_stored(message)"
              class="fa fa-times-circle"
              style="font-size:10px"
            ></i>
            <i
              v-else-if="is_received(message)"
              style="font-size:10px; margin-right: 5px;"
              >{{ $t("received") }}</i
            >
            <i
              v-else-if="is_read(message)"
              style="font-size:10px; margin-right: 5px;"
              >{{ $t("read") }}</i
            >
            <i
              v-else-if="is_error(message)"
              class="el-icon-warning"
              style="cursor: pointer;"
              @click="resendButtonClicked(message)"
            ></i>
            <i
              v-if="can_recall(message)"
              class="el-icon-delete"
              style="cursor: pointer;"
              @click="recallButtonClicked(message)"
            ></i>
          </div>
        </div>
      </li>
    </ul>
    <!-- <p v-if="loadingMoreMessage">加载中...</p>
    <p v-if="noMoreMessage">没有更多了</p> -->
    <!-- 用户卡片 -->
    <el-popover
      ref="visitorcard"
      trigger="hover"
      placement="right-start"
      popper-class="no-padding"
      :visible-arrow="false"
    >
      <VisitorCard />
    </el-popover>
    <el-dialog
      v-dialogDrag
      title="提示"
      :visible.sync="recallDialogVisible"
      width="30%"
      center
    >
      <span>{{ $t("recallAsure") }}:{{ recallMessage.content }}?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="recallDialogVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button type="primary" @click="doRecallMessage">{{
          $t("ok")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog
      v-dialogDrag
      title="语音播放器"
      :modal="false"
      width="30%"
      :visible.sync="dialogTableVisible"
      center
    >
      <iframe :src="player_url"></iframe>
    </el-dialog> -->
    <!-- 图片查看器 -->
    <MeEditorImageView
      ref="imageViewer"
      v-model="imageViewer.isShow"
      :file="imageViewer.file"
      @confirm="confirmUploadImage"
    />
    <!-- 转发此消息 -->
    <el-dialog
      v-dialogDrag
      :title="transferToDialogTitle"
      :visible.sync="transferToDialogVisible"
      width="50%"
      center
    >
      <el-transfer
        v-model="transferToThreads"
        :data="transferUserThreadData"
        :titles="[currentThreadListTip, sendToThreadListTip]"
      ></el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button @click="transferToDialogVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click="sendTransferToMessage"
          :disabled="transferToThreads.length === 0"
          >{{ $t("send") }}</el-button
        >
      </span>
    </el-dialog>
    <!-- TODO: 回复此消息 -->
    <el-dialog
      v-dialogDrag
      :title="replyToDialogTitle"
      :visible.sync="replyToDialogVisible"
      width="30%"
      center
    >
      <el-input type="textarea" v-model="replyToContent"></el-input>
      <p>{{ replyToDialogTitle }} "{{ replyedToContent }}"</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="replyToDialogVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button type="primary" @click="sendReplyToMessage">{{
          $t("send")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- <el-backtop target="#bd-message" :bottom="100"></el-backtop> -->
    <!-- https://github.com/chiic/vue-contextmenu -->
    <vue-context-menu
      :contextMenuData="contextMenuData"
      @HandlerCopy="Handler_copy()"
      @HandlerResend="Handler_resend()"
      @HandlerAddCuw="Handler_addCuw()"
      @HandlerTransfer="Handler_transfer()"
      @HandlerReplyTo="Handler_replyTo()"
      @HandlerTranslateToZh="Handler_translateToZh()"
      @HandlerRecall="Handler_recall()"
    ></vue-context-menu>
    <vue-context-menu
      :contextMenuData="imageContextMenuData"
      @HandlerCopy="Handler_copy()"
      @HandlerResend="Handler_resend()"
      @HandlerAddCuw="Handler_addCuw()"
      @HandlerTransfer="Handler_transfer()"
      @HandlerReplyTo="Handler_replyTo()"
      @HandlerTranslateToZh="Handler_translateToZh()"
      @HandlerRecall="Handler_recall()"
      @HandlerCopyImage="Handler_copyImage()"
      @HandlerOpenImage="Handler_openImage()"
      @HandlerSaveImage="Handler_saveImage()"
    ></vue-context-menu>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import * as constants from "@/util/constants";
import bus from "@/util/eventbus";
let util = require("@/util/util");
import VisitorCard from "@/components/dashboard/setting/VisitorCard";
import MeEditorImageView from "../widgets/editor/MeEditorImageView";
import { getPasteImgs, getDragPasteImg } from "@/util/editor";

export default {
  name: "bd-message",
  components: {
    VisitorCard,
    MeEditorImageView,
  },
  data() {
    return {
      // imageDialogVisible: false,
      rightClickMessage: {
        mid: "",
        type: "",
        content: "",
      },
      recallMessage: {
        mid: "",
        content: "",
      },
      recallDialogVisible: false,
      // currentImageUrl: "",
      currentVoiceUrl: "",
      // currentVideoUrl: '',
      // dialogTableVisible: false,
      emojiBaseUrl: constants.EMOJI_BASE_URL,
      electron: constants.IS_ELECTRON,
      transformDegree: 0,
      visible: false,
      loadingInstance: null,
      isDebug: !constants.IS_PRODUCTION,
      //
      currentPage: 1,
      pageSize: 10,
      loadingMoreMessage: false,
      //
      timer: "",
      // loadingWidget: "",
      showLoading: false,
      // 图片查看器相关信息
      imageViewer: {
        isShow: false,
        file: null,
      },
      // 转发此消息dialog
      transferToDialogVisible: false,
      transferToContent: "",
      transferToThreads: [],
      // 回复此消息dialog
      replyToDialogVisible: false,
      replyToContent: "",
      // 接收图片服务器地址
      // uploadImageServerUrl: constants.UPLOAD_IMAGE_URL,
      uploadImageServerUrl: constants.UPLOAD_FILE_URL_V3,
      // uploadFileServerUrl: constants.UPLOAD_FILE_URL,
      //
      contextMenuData: {
        menuName: "contextMenu",
        axis: {
          x: null,
          y: null,
        },
        menulists: [
          {
            btnName: this.$t("copy"),
            icoName: "el-icon-copy-document",
            fnHandler: "HandlerCopy",
          },
          {
            btnName: this.$t("resend"),
            icoName: "el-icon-position",
            fnHandler: "HandlerResend",
          },
          {
            btnName: this.$t("addToCuw"),
            icoName: "el-icon-plus",
            fnHandler: "HandlerAddCuw",
          },
          {
            btnName: this.$t("transferTo"),
            icoName: "el-icon-refresh",
            fnHandler: "HandlerTransfer",
          },
          // {
          //   btnName: this.$t("replyTo"),
          //   icoName: "el-icon-sort",
          //   fnHandler: "HandlerReplyTo",
          // },
          {
            btnName: this.$t("translateToZh"),
            icoName: "el-icon-refresh",
            fnHandler: "HandlerTranslateToZh",
          },
          // {
          //   btnName: this.$t("recall"),
          //   icoName: "el-icon-delete",
          //   fnHandler: "HandlerRecall",
          // },
        ],
      },
      imageContextMenuData: {
        menuName: "imageContextMenu",
        axis: {
          x: null,
          y: null,
        },
        menulists: [
          {
            btnName: this.$t("copy"),
            icoName: "el-icon-copy-document",
            fnHandler: "HandlerCopy",
          },
          {
            btnName: this.$t("resend"),
            icoName: "el-icon-position",
            fnHandler: "HandlerResend",
          },
          {
            btnName: this.$t("addToCuw"),
            icoName: "el-icon-plus",
            fnHandler: "HandlerAddCuw",
          },
          {
            btnName: this.$t("transferTo"),
            icoName: "el-icon-refresh",
            fnHandler: "HandlerTransfer",
          },
          // {
          //   btnName: this.$t("replyTo"),
          //   icoName: "el-icon-sort",
          //   fnHandler: "HandlerReplyTo",
          // },
          {
            btnName: this.$t("copyImage"),
            icoName: "el-icon-document-copy",
            fnHandler: "HandlerCopyImage",
          },
          {
            btnName: this.$t("openImage"),
            icoName: "el-icon-full-screen",
            fnHandler: "HandlerOpenImage",
          },
          {
            btnName: this.$t("saveImage"),
            icoName: "el-icon-download",
            fnHandler: "HandlerSaveImage",
          },
          // {
          //   btnName: this.$t("recall"),
          //   icoName: "el-icon-delete",
          //   fnHandler: "HandlerRecall",
          // },
        ],
      },
    };
  },
  computed: {
    // 'messages',
    ...mapGetters([
      "userInfo",
      "disabled",
      "userThreads",
      "userCurrentThread",
      "userCurrentThreadMore",
      "userCurrentContact",
      "userCurrentGroup",
      "protobufMessages",
      "showAuthority",
      "connectionStatus",
      "userCurrentTicket",
    ]),
    ...mapState(["emotionMap", "emotionWxMap"]),
    // disabled() {
    //   return this.userCurrentThread.id === 0;
    // },
    isTicketThread() {
      return (
        this.userCurrentThread.type ===
          constants.THREAD_TYPE_TICKET_WORKGROUP ||
        this.userCurrentThread.type === constants.THREAD_TYPE_TICKET_APPOINTED
      );
    },
    show_header() {
      return true;
    },
    noMoreMessage() {
      // return this.count >= 20
      return this.userCurrentThread.last;
    },
    // loadDisabled () {
    //   return this.loadingMoreMessage || this.noMoreMessage
    // },
    previewImageSrcList() {
      let previewImageSrcList = [];
      for (let i = 0; i < this.protobufMessages.length; i++) {
        const element = this.protobufMessages[i];
        if (element.type === constants.MESSAGE_TYPE_IMAGE) {
          previewImageSrcList.push(element.imageUrl);
        }
      }
      return previewImageSrcList;
    },
    //
    agentCloseThreadTip() {
      return this.$t("agentCloseThread");
    },
    visitorCloseThreadTip() {
      return this.$t("visitorCloseThread");
    },
    autoCloseThreadTip() {
      return this.$t("autoCloseThread");
    },
    threadReentryTip() {
      return this.$t("threadReentry");
    },
    visitorConnectTip() {
      return this.$t("visitorConnect");
    },
    visitorDisconnectTip() {
      return this.$t("visitorDisconnect");
    },
    agentOfflineTip() {
      return this.$t("agentOffline");
    },
    inviteRateTip() {
      return this.$t("inviteRate");
    },
    rateResultTip() {
      return this.$t("rateResult");
    },
    inviteVideoThreadTip() {
      return this.$t("inviteVideoThread");
    },
    inviteAudioThreadTip() {
      return this.$t("inviteAudioThread");
    },
    joinQueueThreadTip() {
      return this.$t("joinQueueThread");
    },
    viewVideoTip() {
      return this.$t("viewVideo");
    },
    replyToDialogTitle() {
      return this.$t("replyTo");
    },
    haveNoDataTip() {
      return this.$t("haveNoData");
    },
    replyedToContent() {
      if (this.is_type_text(this.rightClickMessage)) {
        return this.rightClickMessage.content;
      } else if (this.is_type_image(this.rightClickMessage)) {
        return this.rightClickMessage.imageUrl;
      } else if (this.is_type_file(this.rightClickMessage)) {
        return this.rightClickMessage.fileUrl;
      } else if (this.is_type_voice(this.rightClickMessage)) {
        return this.rightClickMessage.voiceUrl;
      } else if (this.is_type_video(this.rightClickMessage)) {
        return this.rightClickMessage.videoOrShortUrl;
      }
      return this.rightClickMessage.content;
    },
    transferToDialogTitle() {
      return this.$t("transferTo");
    },
    currentThreadListTip() {
      return this.$t("currentThreadList");
    },
    sendToThreadListTip() {
      return this.$t("sendToThreadList");
    },
    transferUserThreadData() {
      const data = [];
      let app = this;
      this.userThreads.forEach((thread, index) => {
        if (thread.topic !== app.userCurrentThread.topic) {
          data.push({
            label: thread.nickname,
            key: thread.topic,
          });
        }
      });
      return data;
    },
  },
  watch: {
    userCurrentThread(newThread, oldThread) {
      // console.log('userCurrentThread changed')
      this.currentPage = 1
    }
  },
  methods: {
    ...mapActions([
      "getMessages",
      "sendMessageRest",
      "updateMessageStatus",
      "baiduTranslate",
    ]),
    ...mapActions("mqtt", ["sendMessageProtobuf", "sendMessageJsonRest"]), // , 'sendMessageProtobuf2'
    // 专门用于electron contextMenu
    showContextMenu() {
      // this.transferIndex = index; // tranfer index to child component
      event.preventDefault();
      var x = event.clientX;
      var y = event.clientY;
      this.contextMenuData.axis = {
        x,
        y,
      };
    },
    showImageContextMenu() {
      // this.transferIndex = index; // tranfer index to child component
      event.preventDefault();
      var x = event.clientX;
      var y = event.clientY;
      this.imageContextMenuData.axis = {
        x,
        y,
      };
    },
    Handler_copy() {
      // 复制
      this.rightCopyButtonClicked();
    },
    Handler_resend() {
      // 重新发送
      this.rightResendButtonClicked(this.rightClickMessage);
    },
    Handler_addCuw() {
      // 添加到常用语/快捷回复
      this.rightAddCuwButtonClicked();
    },
    Handler_transfer() {
      // 转发
      this.rightTransferButtonClicked();
    },
    Handler_replyTo() {
      // 回复消息
      this.rightReplyToButtonClicked();
    },
    Handler_translateToZh() {
      // 翻译
      this.rightTranslateButtonClicked();
    },
    Handler_recall() {
      // 消息撤回
      this.rightRecallButtonClicked()
    },
    Handler_copyImage() {
      // 复制图片
      this.rightCopyImageButtonClicked()
    },
    Handler_openImage() {
      // 打开图片
      this.rightOpenImageButtonClicked()
    },
    Handler_saveImage() {
      // 本地保存图片
      this.rightSaveImageButtonClicked()
    },
    jsonObject(content) {
      return content === null
        ? '{"categoryCode":"","content":"","id":0,"imageUrl":"","price":"","title":"","type":"commodity","url":""}'
        : JSON.parse(content);
    },
    formObject(content) {
      return content === null
        ? '{"form":{"realname":"test1","mobile":"13311158888","email":"","age":0,"job":""}}'
        : JSON.parse(content);
    },
    formatLocation(message) {
      return (
        message.label + "(" + message.locationX + "," + message.locationY + ")"
      );
    },
    formatEvent(message) {
      return message.content === "event_agent"
        ? this.$t("event_agent")
        : message.content;
    },
    formatChannelTitle(message) {
      return JSON.parse(message.content).title;
    },
    formatChannelContent(message) {
      return JSON.parse(message.content).content;
    },
    getMoreMessages() {
      console.log('this.currentPage: ', this.currentPage)
      this.showLoading = true;
      let payload = {
        page: this.currentPage,
        size: this.pageSize,
        scroll: false,
      };
      this.getMessages(payload);
      this.currentPage += 1;
    },
    nicknameClicked(nickname) {
      // console.log('text clicked:', message.mid, message.content)
      this.copyTextToClipboard(nickname);
      // this.$message('"' + nickname + '" ' + this.$t("copiedToClip"));
    },
    textClicked(message) {
      // console.log('text clicked:', message.mid, message.content)
      this.copyTextToClipboard(message.content);
      // let content = message.content.replaceAll('amp;', '')
      // this.copyTextToClipboard(content);
      // this.$message('"' + content + '" ' + this.$t("copiedToClip"));
      // 10分钟之内允许撤回
      // if (this.can_recall(message)) {
      //   this.recallMessage = message
      //   this.recallDialogVisible = true
      // }
    },
    rightResendButtonClicked(message) {
      // 右键重新发送，作为全新消息发送
      let mid = util.guid();
      // 发送长连接消息
      let payload = {};
      if (this.is_type_text(message)) {
        payload = {
          mid: mid,
          type: constants.MESSAGE_TYPE_TEXT,
          content: message.content,
          thread: this.userCurrentThread,
        };
      } else if (this.is_type_image(message)) {
        payload = {
          mid: mid,
          type: constants.MESSAGE_TYPE_IMAGE,
          content: message.imageUrl,
          thread: this.userCurrentThread,
        };
      } else if (this.is_type_file(message)) {
        payload = {
          mid: mid,
          type: constants.MESSAGE_TYPE_FILE,
          content: message.fileUrl,
          thread: this.userCurrentThread,
        };
      } else if (this.is_type_voice(message)) {
        payload = {
          mid: mid,
          type: constants.MESSAGE_TYPE_VOICE,
          content: message.voiceUrl,
          thread: this.userCurrentThread,
        };
      } else if (this.is_type_video(message)) {
        payload = {
          mid: mid,
          type: constants.MESSAGE_TYPE_VIDEO,
          content: message.videoOrShortUrl,
          thread: this.userCurrentThread,
        };
      }
      this.sendMessageProtobuf(payload);
    },
    resendButtonClicked(message) {
      // console.log('resend msg clicked:', message.mid, message.content)
      // 发送失败的消息重新发送，使用原消息mid
      let mid = message.mid;
      // 发送长连接消息
      let payload = {};
      if (this.is_type_text(message)) {
        payload = {
          mid: mid,
          type: constants.MESSAGE_TYPE_TEXT,
          content: message.content,
          thread: this.userCurrentThread,
        };
      } else if (this.is_type_image(message)) {
        payload = {
          mid: mid,
          type: constants.MESSAGE_TYPE_IMAGE,
          content: message.imageUrl,
          thread: this.userCurrentThread,
        };
      } else if (this.is_type_file(message)) {
        payload = {
          mid: mid,
          type: constants.MESSAGE_TYPE_FILE,
          content: message.fileUrl,
          thread: this.userCurrentThread,
        };
      } else if (this.is_type_voice(message)) {
        payload = {
          mid: mid,
          type: constants.MESSAGE_TYPE_VOICE,
          content: message.voiceUrl,
          thread: this.userCurrentThread,
        };
      } else if (this.is_type_video(message)) {
        payload = {
          mid: mid,
          type: constants.MESSAGE_TYPE_VIDEO,
          content: message.videoOrShortUrl,
          thread: this.userCurrentThread,
        };
      }
      this.sendMessageJsonRest(payload);
    },
    recallButtonClicked(message) {
      // console.log('recall msg clicked:', message.mid, message.content)
      // 3分钟之内允许撤回
      if (this.can_recall(message)) {
        this.recallMessage = message;
        this.recallDialogVisible = true;
      } else {
        this.$message({ message: '已超时，暂不支持撤回', type: 'warning' });
      }
    },
    rightCopyButtonClicked() {
      //
      if (this.is_type_text(this.rightClickMessage)) {
        this.copyTextToClipboard(this.rightClickMessage.content);
      } else if (this.is_type_image(this.rightClickMessage)) {
        this.copyTextToClipboard(this.rightClickMessage.imageUrl);
      } else if (this.is_type_file(this.rightClickMessage)) {
        this.copyTextToClipboard(this.rightClickMessage.fileUrl);
      } else if (this.is_type_voice(this.rightClickMessage)) {
        this.copyTextToClipboard(this.rightClickMessage.voiceUrl);
      } else if (this.is_type_video(this.rightClickMessage)) {
        this.copyTextToClipboard(this.rightClickMessage.videoOrShortUrl);
      } else {
        this.copyTextToClipboard(this.rightClickMessage.content);
      }
    },
    rightAddCuwButtonClicked() {
      //
      if (this.is_type_text(this.rightClickMessage)) {
        bus.$emit(
          constants.EVENT_BUS_ADD_MESSAGE_TO_CUW,
          this.rightClickMessage
        );
      } else if (this.is_type_image(this.rightClickMessage)) {
        bus.$emit(
          constants.EVENT_BUS_ADD_MESSAGE_TO_CUW,
          this.rightClickMessage
        );
      } else if (this.is_type_file(this.rightClickMessage)) {
        bus.$emit(
          constants.EVENT_BUS_ADD_MESSAGE_TO_CUW,
          this.rightClickMessage
        );
      } else if (this.is_type_voice(this.rightClickMessage)) {
        bus.$emit(
          constants.EVENT_BUS_ADD_MESSAGE_TO_CUW,
          this.rightClickMessage
        );
      } else if (this.is_type_video(this.rightClickMessage)) {
        bus.$emit(
          constants.EVENT_BUS_ADD_MESSAGE_TO_CUW,
          this.rightClickMessage
        );
      } else if (this.is_type_card(this.rightClickMessage)) {
        bus.$emit(
          constants.EVENT_BUS_ADD_MESSAGE_TO_CUW,
          this.rightClickMessage
        );
      }
    },
    rightTransferButtonClicked() {
      //
      this.transferToDialogVisible = true;
    },
    rightReplyToButtonClicked() {
      //
      this.replyToDialogVisible = true;
    },
    handleTranslateSuccessResult(response) {
      // console.log('baiduTranslate success 2:', response)
      if (response.status_code === 200) {
        //
      } else {
        this.$message.error(response.data);
      }
      if (this.loadingInstance) {
        this.loadingInstance.close();
      }
    },
    handleTranslateFailedResult(error) {
      // console.log('baiduTranslate error:', error)
      this.$message.error(error);
      if (this.loadingInstance) {
        this.loadingInstance.close();
      }
    },
    rightTranslateButtonClicked() {
      console.log("rightTranslateButtonClicked");
      if (this.is_type_text(this.rightClickMessage)) {
        // 翻译成：中文
        let payload = {
          mid: this.rightClickMessage.mid,
          q: this.rightClickMessage.content,
          from: "auto",
          to: "zh",
          successcb: this.handleTranslateSuccessResult,
          failedcb: this.handleTranslateFailedResult,
        };
        this.baiduTranslate(payload);
        // 显示loading
        this.loadingInstance = this.$loading({
          fullscreen: false,
          target: document.querySelector(
            "[id='" + this.rightClickMessage.mid + "']"
          ),
        });
      } else {
        this.$message.error("不支持翻译此类型消息");
      }
    },
    rightRecallButtonClicked() {
      // console.log('rightRecallButtonClicked')
      //
      this.recallButtonClicked(this.rightClickMessage)
    },
    rightCopyImageButtonClicked() {
      console.log('rightCopyImageButtonClicked FIXME:跨域问题，web无法正常复制图片到剪贴板')
      // 复制图片到剪贴板
      this.copyImageToClipboard(this.rightClickMessage.imageUrl)
    },
    rightOpenImageButtonClicked() {
      // console.log('rightOpenImageButtonClicked')
      // 打开图片
      if (this.electron) {
        ipcRenderer.send("open-external-url", this.rightClickMessage.imageUrl);
      } else {
        window.open(this.rightClickMessage.imageUrl);
      }
    },
    rightSaveImageButtonClicked() {
      console.log('rightSaveImageButtonClicked FIXME: 跨域问题，web无法正常下载图片')
      // 本地保存图片
      this.downloadImage(this.rightClickMessage.imageUrl, '图片')
    },
    fileClicked(fileUrl) {
      if (this.electron) {
        ipcRenderer.send("open-external-url", fileUrl);
      } else {
        window.open(fileUrl);
      }
    },
    voiceClicked(voiceUrl) {
      // console.log('voice clicked:', voiceUrl)
      this.currentVoiceUrl = voiceUrl;
      if (this.electron) {
        ipcRenderer.send("open-external-url", voiceUrl);
      } else {
        window.open(voiceUrl);
      }
    },
    videoClicked(videoUrl) {
      // console.log('voice clicked:', voiceUrl)
      // this.currentVideoUrl = videoUrl
      if (this.electron) {
        ipcRenderer.send("open-external-url", videoUrl);
      } else {
        window.open(videoUrl);
      }
    },
    transformLarger() {
      console.log("transformLarger");
      let currentImage = document.getElementById("currentImage");
      currentImage.width = currentImage.width * 1.1;
      currentImage.height = currentImage.height * 1.1;
    },
    transformSmaller() {
      console.log("transformSmaller");
      let currentImage = document.getElementById("currentImage");
      currentImage.width = currentImage.width * 0.9;
      currentImage.height = currentImage.height * 0.9;
    },
    transformLeft() {
      this.transformDegree -= 90;
      document.getElementById("currentImage").style.transform =
        "rotate(" + this.transformDegree + "deg)";
    },
    transformRight() {
      this.transformDegree += 90;
      document.getElementById("currentImage").style.transform =
        "rotate(" + this.transformDegree + "deg)";
    },
    is_self(message) {
      // return !message.user.visitor
      return (
        // message.client === constants.CLIENT_SYSTEM ||
        message.user.uid === this.userInfo.uid
      );
    },
    // 发送状态
    is_sending(message) {
      return message.status === constants.MESSAGE_STATUS_SENDING;
    },
    is_stored(message) {
      return message.status === constants.MESSAGE_STATUS_STORED;
    },
    is_received(message) {
      return message.status === constants.MESSAGE_STATUS_RECEIVED;
    },
    is_error(message) {
      return message.status === constants.MESSAGE_STATUS_ERROR;
    },
    is_read(message) {
      return message.status === constants.MESSAGE_STATUS_READ;
    },
    can_recall(message) {
      return (
        this.callRecallMessage(message) &&
        this.is_self(message) &&
        (message.type === constants.MESSAGE_TYPE_TEXT ||
          message.type === constants.MESSAGE_TYPE_IMAGE ||
          message.type === constants.MESSAGE_TYPE_VOICE||
          message.type === constants.MESSAGE_TYPE_VIDEO||
          message.type === constants.MESSAGE_TYPE_FILE)
      );
    },
    // 消息类型
    is_type_text(message) {
      return (
        message.type === constants.MESSAGE_TYPE_TEXT ||
        message.type === constants.MESSAGE_TYPE_NOTIFICATION_THREAD
      );
    },
    is_type_robot(message) {
      return message.type === constants.MESSAGE_TYPE_ROBOT;
    },
    is_type_robotv2(message) {
      return message.type === constants.MESSAGE_TYPE_ROBOTV2;
    },
    is_type_image(message) {
      return message.type === constants.MESSAGE_TYPE_IMAGE;
    },
    is_type_file(message) {
      return message.type === constants.MESSAGE_TYPE_FILE;
    },
    is_type_voice(message) {
      return message.type === constants.MESSAGE_TYPE_VOICE;
    },
    is_type_video(message) {
      return (
        message.type === constants.MESSAGE_TYPE_VIDEO ||
        message.type === constants.MESSAGE_TYPE_SHORT_VIDEO
      );
    },
    is_type_card(message) {
      return message.type === constants.MESSAGE_TYPE_CARD;
    },
    is_type_choice(message) {
      return message.type === constants.MESSAGE_TYPE_CHOICE
    },
    is_type_survey(message) {
      return message.type === constants.MESSAGE_TYPE_SURVEY
    },
    // is_type_shortvideo (message) {
    //   return message.type === constants.MESSAGE_TYPE_SHORT_VIDEO
    // },
    is_type_location(message) {
      return message.type === constants.MESSAGE_TYPE_LOCATION;
    },
    is_type_link(message) {
      return message.type === constants.MESSAGE_TYPE_LINK;
    },
    is_type_event(message) {
      return message.type === constants.MESSAGE_TYPE_EVENT;
    },
    is_type_custom(message) {
      return message.type === constants.MESSAGE_TYPE_CUSTOM;
    },
    is_type_red_packet(message) {
      return message.type === constants.MESSAGE_TYPE_RED_PACKET;
    },
    is_type_commodity(message) {
      return message.type === constants.MESSAGE_TYPE_COMMODITY;
    },
    is_type_channels_shop_product(message) {
      // 视频号商品消息
      return message.type === constants.MESSAGE_TYPE_CHANNELS_SHOP_PRODUCT
    },
    is_type_channels_shop_order(message) {
      // 视频号订单消息
      return message.type === constants.MESSAGE_TYPE_CHANNELS_SHOP_ORDER
    },
    is_type_questionnaire(message) {
      return message.type === constants.MESSAGE_TYPE_QUESTIONNAIRE;
    },
    is_type_company(message) {
      return message.type === constants.MESSAGE_TYPE_COMPANY;
    },
    is_type_workGroup(message) {
      return message.type === constants.MESSAGE_TYPE_WORK_GROUP;
    },
    is_type_channel(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_CHANNEL;
    },
    is_type_ticket(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_TICKET;
    },
    is_type_feedback(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_FEEDBACK;
    },
    is_type_notification(message) {
      return (
        message.type !== constants.MESSAGE_TYPE_NOTIFICATION_THREAD &&
        message.type !== constants.MESSAGE_TYPE_NOTIFICATION_FORM_REQUEST &&
        message.type !== constants.MESSAGE_TYPE_NOTIFICATION_FORM_RESULT &&
        message.type !== constants.MESSAGE_TYPE_NOTIFICATION_CHANNEL &&
        // message.type !== constants.MESSAGE_TYPE_NOTIFICATION_TICKET &&
        // message.type !== constants.MESSAGE_TYPE_NOTIFICATION_FEEDBACK &&
        message.type.startsWith(constants.MESSAGE_TYPE_NOTIFICATION)
      );
    },
    is_type_notification_agent_close(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_AGENT_CLOSE;
    },
    is_type_notification_visitor_close(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_VISITOR_CLOSE;
    },
    is_type_notification_auto_close(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_AUTO_CLOSE;
    },
    is_type_notification_thread_reentry(message) {
      return (
        message.type === constants.MESSAGE_TYPE_NOTIFICATION_THREAD_REENTRY
      );
    },
    is_type_notification_connect(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_CONNECT;
    },
    is_type_notification_disconnect(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_DISCONNECT;
    },
    is_type_notification_offline(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_OFFLINE;
    },
    is_type_notification_invite_rate(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_INVITE_RATE;
    },
    is_type_notification_rate_result(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_RATE_RESULT;
    },
    is_type_notification_invite_video(message) {
      return (
        message.type === constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_INVITE_VIDEO
      );
    },
    is_type_notification_invite_audio(message) {
      return (
        message.type === constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_INVITE_AUDIO
      );
    },
    is_type_notification_queue(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_QUEUE;
    },
    is_type_notification_queue_accept(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_QUEUE_ACCEPT;
    },
    is_type_form_request(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_FORM_REQUEST;
    },
    is_type_form_result(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_FORM_RESULT;
    },
    is_type_transfer(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_TRANSFER;
    },
    is_type_transfer_accept(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_TRANSFER_ACCEPT;
    },
    is_type_transfer_reject(message) {
      return message.type === constants.MESSAGE_TYPE_NOTIFICATION_TRANSFER_REJECT;
    },
    fromClient(message) {
      let client = message.client;
      if (client.startsWith("web_pc")) {
        client = "web";
      } else if (client.startsWith("web_h5")) {
        client = "h5";
      } else if (client.startsWith("web")) {
        client = "web/h5";
      } else if (client.startsWith("android")) {
        client = this.$t("android");
      } else if (client.startsWith("ios")) {
        client = this.$t("ios");
      } else if (client.startsWith("wechat_mp")) {
        client = this.$t("wechat_mp");
      } else if (client.startsWith("wechat_mini")) {
        client = this.$t("wechat_mini");
      } else if (client.startsWith("wechat_kefu")) {
        client = this.$t("wechat_kefu");
      } else if (client.startsWith("flutter_android")) {
        client = this.$t("flutter_android");
      } else if (client.startsWith("flutter_ios")) {
        client = this.$t("flutter_ios");
      } else if (client.startsWith("flutter_web")) {
        client = this.$t("flutter_web");
      }
      return "[" + client + "]";
    },
    player_url() {
      return constants.VOICE_PLAYER_BASE_URL + this.currentVoiceUrl;
    },
    // 识别链接, FIXME: 对于不带http(s)前缀的url，会被识别为子链接，点击链接无法跳出
    replaceUrl(content) {
      if (!content) {
        return content;
      }
      const urlPattern = /(https?:\/\/|www\.)[a-zA-Z_0-9\-@]+(\.\w[a-zA-Z_0-9\-:]+)+(\/[()~#&\-=?+%/.\w]+)?/g;
      return content.replace(urlPattern, (url) => {
        // console.log('url:', url)
        return `<a href="${url}" target="_blank">${url}</a>`;
      });
    },
    replaceUrlScheme(text) {
      const urlRegex = /(\b[a-z]+:\/\/\S+)/gi;
      return text.replace(urlRegex, '<a href="$1" target="_blank">$1</a>');
    },
    //  在发送信息之后，将输入的内容中属于表情的部分替换成emoji图片标签
    //  再经过v-html 渲染成真正的图片
    // TODO: 解析微信表情
    replaceFace(content) {
      if (content == null || content == undefined) {
        return content;
      }
      // 识别链接
      let replaceUrl = this.replaceUrlScheme(content);
      // console.log('replace url:', replaceUrl)
      //
      var wxConttent = this.replaceWeChatFace(replaceUrl);
      var emotionMap = this.emotionMap;
      var reg = /\[[\u4E00-\u9FA5NoOK]+\]/g;
      var matchresult = wxConttent.match(reg);
      var result = wxConttent;
      if (matchresult) {
        for (var i = 0; i < matchresult.length; i++) {
          result = result.replace(
            matchresult[i],
            "<img height='25px' width='25px' style='margin-bottom:4px;' src='" +
              this.emojiBaseUrl +
              emotionMap[matchresult[i]] +
              "'>"
          );
        }
      }

      return result;
    },
    replaceWeChatFace(content) {
      if (content == null || content == undefined) {
        return content;
      }
      var emotionMap = this.emotionWxMap;
      var reg = /\/::\)|\/::~|\/::B|\/::\||\/:8-\)|\/::<|\/::\$|\/::X|\/::Z|\/::'\\(|\/::-\||\/::@|\/::P|\/::D|\/::O|\/::\\(|\/::\+|\/:--b|\/::Q|\/::T|\/:,@P|\/:,@-D|\/::d|\/:,@o|\/::g|\/:\\|-\\)|\/::!|\/::L|\/::>|\/::,@|\/:,@f|\/::-S|\/:\\?|\/:,@x|\/:,@@|\/::8|\/:,@!|\/:!!!|\/:xx|\/:bye|\/:wipe|\/:dig|\/:handclap|\/:&-\\(|\/:B-\\)|\/:<@|\/:@>|\/::-O|\/:>-\\||\/:P-\\(|\/::'\\||\/:X-\\)|\/::\\*|\/:@x|\/:8\\*|\/:pd|\/:<W>|\/:beer|\/:basketb|\/:oo|\/:coffee|\/:eat|\/:pig|\/:rose|\/:fade|\/:showlove|\/:heart|\/:break|\/:cake|\/:li|\/:bome|\/:kn|\/:footb|\/:ladybug|\/:shit|\/:moon|\/:sun|\/:gift|\/:hug|\/:strong|\/:weak|\/:share|\/:v|\/:@\\)|\/:jj|\/:@@|\/:bad|\/:lvu|\/:no|\/:ok|\/:love|\/:<L>|\/:jump|\/:shake|\/:<O>|\/:circle|\/:kotow|\/:turn|\/:skip|\/:oY|\/:#-0|\/:hiphot|\/:kiss|\/:<&|\/:&>/g;
      var matchresult = content.match(reg);
      var result = content;
      if (matchresult) {
        for (var i = 0; i < matchresult.length; i++) {
          result = result.replace(
            matchresult[i],
            "<img height='25px' width='25px' style='margin-bottom:4px;' src='" +
              this.emojiBaseUrl +
              emotionMap[matchresult[i]] +
              "'>"
          );
        }
      }
      return result;
    },
    handleImageDialogClose(done) {
      done();
    },
    scrollToBottom() {
      // 聊天记录滚动到最底部
      let vm = this;
      this.$nextTick(() => {
        const ul = vm.$refs.list;
        if (ul != null) {
          ul.scrollTop = ul.scrollHeight;
        }
      });
    },
    // 撤回消息
    doRecallMessage() {
      this.recallDialogVisible = false;
      // console.log("recallMessage:", this.recallMessage.mid, this.recallMessage.content);
      //
      let payload = {
        type: constants.MESSAGE_TYPE_NOTIFICATION_RECALL,
        content: this.recallMessage.mid,
        thread: this.userCurrentThread,
      };
      this.sendMessageProtobuf(payload);
    },
    // 检测是否在10分钟之内，允许撤回消息
    callRecallMessage(message) {
      let now = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
      let createdAt = moment(message.createdAt, "YYYY-MM-DD HH:mm:ss");
      let seconds = now.diff(createdAt, "seconds");
      // 现在距消息发送的时间差
      // console.log('seconds passed: ', seconds)
      if (seconds < 60 * 10) {
        return true;
      }
      return false;
    },
    // 鼠标右键
    rightEvent(message) {
      // console.log('点击右键', message)
      this.rightClickMessage = message;
    },
    // 引用第三方组件: https://github.com/GitHub-Laziji/menujs
    onContextmenu(event) {
      if (this.electron) {
        this.showContextMenu();
        return;
      }
      // TODO: 判断是图片：增加打开预览；判断是文件：增加打开文件；
      this.$contextmenu({
        items: [
          {
            label: this.$t("copy"),
            icon: "el-icon-copy-document",
            onClick: () => {
              this.rightCopyButtonClicked();
            },
          },
          {
            label: this.$t("resend"),
            icon: "el-icon-position",
            onClick: () => {
              this.rightResendButtonClicked(this.rightClickMessage);
            },
          },
          {
            // 添加到快捷回复
            label: this.$t("addToCuw"),
            icon: "el-icon-plus",
            onClick: () => {
              this.rightAddCuwButtonClicked();
            },
          },
          // TODO: 收藏
          // 转发
          {
            label: this.$t("transferTo"),
            icon: "el-icon-refresh",
            onClick: () => {
              // this.transferToDialogVisible = true;
              this.rightTransferButtonClicked();
            },
          },
          // 翻译
          {
            label: this.$t("translateToZh"),
            icon: "el-icon-refresh",
            onClick: () => {
              this.rightTranslateButtonClicked();
            },
          },
          // TODO: 引用 (回复此消息)
          // {
          //   label: this.$t("replyTo"),
          //   icon: "el-icon-sort",
          //   onClick: () => {
          //     // this.replyToDialogVisible = true;
          //     this.rightReplyToButtonClicked();
          //   },
          // },
        ],
        event,
        // customClass: "class-a",
        zIndex: 3,
        minWidth: 130,
      });
      // FIXME: 撤回
      // if (this.can_recall(this.rightClickMessage)) {
      //   this.$contextmenu.items.push(
      //     {
      //       label: this.$t("recall"),
      //       icon: "el-icon-delete",
      //       onClick: () => {
      //         this.rightRecallButtonClicked();
      //       },
      //     },
      //   )
      // }
      return false;
    },
    // 引用第三方组件: https://github.com/GitHub-Laziji/menujs
    onImageContextmenu(event) {
      if (this.electron) {
        this.showImageContextMenu();
        return;
      }
      if (this.isDebug) {
        this.$contextmenu({
          items: [
            {
              label: this.$t("copy"),
              icon: "el-icon-copy-document",
              onClick: () => {
                this.rightCopyButtonClicked();
              },
            },
            {
              label: this.$t("resend"),
              icon: "el-icon-position",
              onClick: () => {
                this.rightResendButtonClicked(this.rightClickMessage);
              },
            },
            {
              // 添加到快捷回复
              label: this.$t("addToCuw"),
              icon: "el-icon-plus",
              onClick: () => {
                this.rightAddCuwButtonClicked();
              },
            },
            // TODO: 收藏
            // 转发
            {
              label: this.$t("transferTo"),
              icon: "el-icon-refresh",
              onClick: () => {
                this.rightTransferButtonClicked();
              },
              divided: true,
            },
            // TODO: 复制图片
            {
              label: "复制图片，FIXME: 跨域", //this.$t("copyImage"),
              icon: "el-icon-document-copy",
              onClick: () => {
                this.rightCopyImageButtonClicked();
              },
            },
            // 打开图片
            {
              label: this.$t("openImage"),
              icon: "el-icon-full-screen",
              onClick: () => {
                this.rightOpenImageButtonClicked();
              },
            },
            // TODO: 保存图片
            {
              label: "保存图片，FIXME: 跨域", // this.$t("saveImage"),
              icon: "el-icon-download",
              onClick: () => {
                this.rightSaveImageButtonClicked();
              },
            },
          ],
          event,
          // customClass: "class-a",
          zIndex: 3,
          minWidth: 130,
        });
      } else {
        this.$contextmenu({
          items: [
            {
              label: this.$t("copy"),
              icon: "el-icon-copy-document",
              onClick: () => {
                this.rightCopyButtonClicked();
              },
            },
            {
              label: this.$t("resend"),
              icon: "el-icon-position",
              onClick: () => {
                this.rightResendButtonClicked(this.rightClickMessage);
              },
            },
            {
              // 添加到快捷回复
              label: this.$t("addToCuw"),
              icon: "el-icon-plus",
              onClick: () => {
                this.rightAddCuwButtonClicked();
              },
            },
            // TODO: 收藏
            // 转发
            {
              label: this.$t("transferTo"),
              icon: "el-icon-refresh",
              onClick: () => {
                this.rightTransferButtonClicked();
              },
              divided: true,
            },
            // 打开图片
            {
              label: this.$t("openImage"),
              icon: "el-icon-full-screen",
              onClick: () => {
                this.rightOpenImageButtonClicked();
              },
            },
          ],
          event,
          // customClass: "class-a",
          zIndex: 3,
          minWidth: 130,
        });
      }
      return false;
    },
    copyTextToClipboard(content) {
      //
      content = content.replaceAll("amp;", "");
      this.$message('"' + content + '" ' + this.$t("copiedToClip"));
      //
      var aux = document.createElement("input");
      aux.setAttribute("value", content);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
    },
    checkTimeoutMessage() {
      // 检测-消息是否超时发送失败
      for (let i = 0; i < this.protobufMessages.length; i++) {
        const message = this.protobufMessages[i];
        if (this.is_self(message) && this.is_sending(message)) {
          let timestamp = moment(message.createdAt);
          let now = moment(new Date());
          let diff = now.diff(timestamp, "seconds");
          // console.log('diff:', diff)
          if (diff > 15) {
            // 超时15秒，设置为消息状态为error
            let payload = {
              mid: message.mid,
              status: constants.MESSAGE_STATUS_ERROR,
            };
            this.updateMessageStatus(payload);
          } else if (diff > 5) {
            // 5秒没有发送成功，则尝试使用http rest接口发送
            let content = "";
            if (message.type === constants.MESSAGE_TYPE_TEXT) {
              content = message.content;
            } else if (message.type === constants.MESSAGE_TYPE_IMAGE) {
              content = message.imageUrl;
            } else if (message.type === constants.MESSAGE_TYPE_FILE) {
              content = message.fileUrl;
            } else {
              content = message.content;
            }
            let payload = {
              mid: message.mid,
              type: message.type,
              content: message.content,
              thread: message.thread,
            };
            this.sendMessageJsonRest(payload);
          }
        }
      }
      // 判断连接状态，如果断开，则调用http-rest接口拉取最新消息
      if (
        this.connectionStatus != constants.STOMP_CONNECTION_STATUS_CONNECTED &&
        !this.userCurrentThread.closed
      ) {
        // let payload = { page: 0, size: 10, scroll: false };
        // this.getMessages(payload) // TODO: 数据库压力过大，暂时注释掉
      }
    },
    //复制粘贴图片回调方法
    pasteImage(e) {
      if (this.disabled) {
        this.$message.error("请先选择会话")
        return
      }
      let files = getPasteImgs(e);
      if (files.length == 0) return;

      this.openImageViewer(files[0]);
    },
    //拖拽上传图片回调方法
    dragPasteImage(e) {
      if (this.disabled) {
        this.$message.error("请先选择会话")
        return
      }
      let files = getDragPasteImg(e);
      if (files.length == 0) return;

      this.openImageViewer(files[0]);
    },
    // 打开图片查看器
    openImageViewer(file) {
      this.imageViewer.isShow = true;
      this.imageViewer.file = file;
    },
    // 确认上传图片消息回调事件
    confirmUploadImage() {
      //
      let file = this.imageViewer.file;
      this.uploadImage(file);
    },
    uploadImage(file) {
      console.log("bdmessage uploadImage");
      //
      let app = this;
      this.compressImage(file, function(newFile) {
        // console.log('compressImage')
        //
        let filename = moment(new Date()).format("YYYYMMDDHHmmss");
        if (file.type === "image/jpeg") {
          filename = filename + ".jpg";
        } else if (file.type === "image/png") {
          filename = filename + ".png";
        }
        //
        var formdata = new FormData();
        formdata.append("file_name", filename);
        formdata.append("username", app.userInfo.username);
        formdata.append("type", constants.UPLOAD_FILE_TYPE_IMAGE)
        formdata.append("file", newFile);
        formdata.append("client", "web");
        //
        let ref = app.$refs.imageViewer;
        // app.$message(app.$t('uploading'))
        $.ajax({
          url: app.uploadImageServerUrl,
          contentType: false,
          cache: false,
          processData: false,
          mimeTypes: "multipart/form-data",
          type: "post",
          data: formdata,
          success: function(response) {
            ref.loading = false;
            ref.closeBox();
            // console.log('upload response:', response.data)
            var imageUrl = response.data;
            let payload = {
              type: constants.MESSAGE_TYPE_IMAGE,
              content: imageUrl,
              thread: app.userCurrentThread,
            };
            app.sendMessageProtobuf(payload);
            // 提示
            app.$message({ message: app.$t("uploadsuccess"), type: "success" });
          },
          error: function(error) {
            ref.loading = false;
            console.log(error);
            // app.$message.error(app.$t('uploadfailed'))
            app.$notify({
              title: app.$t("tip"),
              message: app.$t("sendImageError"),
              type: "error",
            });
          },
        });
      });
    },
    compressImage(file, callback) {
      // 判断文件大小
      if (file.size > 1024 * 1024 * 1) {
        console.log("图片大于1M进行压缩");
        //
        this.canvasDataURL(file, function(blob) {
          //
          var newFile = new File([blob], file.name, {
            type: file.type,
          });
          var isLt1M;
          if (file.size < newFile.size) {
            isLt1M = file.size;
          } else {
            isLt1M = newFile.size;
          }
          console.log("file.size:" + file.size / 1024 / 1024);
          console.log("newFile.size: " + newFile.size / 1024 / 1024);
          //
          if (file.size < newFile.size) {
            callback(file);
          }
          callback(newFile);
        });
      } else {
        console.log("图片小于1M直接上传");
        //
        return callback(file);
      }
    },
    // 图片压缩方法
    canvasDataURL(file, callback) {
      console.log("canvasDataURL");
      //
      let app = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function(e) {
        const img = new Image();
        const quality = 0.1; // 图像质量
        const canvas = document.createElement("canvas");
        const drawer = canvas.getContext("2d");
        img.src = this.result;
        img.onload = function() {
          canvas.width = img.width;
          canvas.height = img.height;
          drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
          return app.convertBase64UrlToBlob(
            canvas.toDataURL("image/jpeg", quality),
            callback
          );
        };
      };
    },
    // 将以base64的图片url数据转换为Blob
    convertBase64UrlToBlob(urlData, callback) {
      console.log("convertBase64UrlToBlob");
      //
      var bytes = window.atob(urlData.split(",")[1]); //去掉url的头，并转换为byte
      //处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      var blob = new Blob([ab], { type: "image/jpeg" });
      callback(blob);
    },
    // 转发
    sendTransferToMessage() {
      // console.log("sendTransferToMessage");
      this.transferToDialogVisible = false;
      // 根据topic查找相应thread
      // console.log("transferToThreads:", this.transferToThreads);
      for (let i = 0; i < this.userThreads.length; i++) {
        const thread = this.userThreads[i];
        for (let j = 0; j < this.transferToThreads.length; j++) {
          const topic = this.transferToThreads[j];
          if (thread.topic === topic) {
            // 发送
            let mid = util.guid();
            // 发送长连接消息
            let payload = {};
            let message = this.rightClickMessage;
            if (this.is_type_text(message)) {
              payload = {
                mid: mid,
                type: constants.MESSAGE_TYPE_TEXT,
                content: message.content,
                thread: thread,
              };
            } else if (this.is_type_image(message)) {
              payload = {
                mid: mid,
                type: constants.MESSAGE_TYPE_IMAGE,
                content: message.imageUrl,
                thread: thread,
              };
            } else if (this.is_type_file(message)) {
              payload = {
                mid: mid,
                type: constants.MESSAGE_TYPE_FILE,
                content: message.fileUrl,
                thread: thread,
              };
            } else if (this.is_type_voice(message)) {
              payload = {
                mid: mid,
                type: constants.MESSAGE_TYPE_VOICE,
                content: message.voiceUrl,
                thread: thread,
              };
            } else if (this.is_type_video(message)) {
              payload = {
                mid: mid,
                type: constants.MESSAGE_TYPE_VIDEO,
                content: message.videoOrShortUrl,
                thread: thread,
              };
            }
            this.sendMessageProtobuf(payload);
          }
        }
      }
    },
    // 引用
    sendReplyToMessage() {
      console.log("sendReplyToMessage");
      this.replyToDialogVisible = false;
      // 发送
      let mid = util.guid();
      // 发送长连接消息
      let payload = {};
      let message = this.rightClickMessage;
      if (this.is_type_text(message)) {
        let msgObject = { type: message.type, content: message.content };
        let content =
          this.replyToContent + "REPLYTO:" + JSON.stringify(msgObject);
        payload = {
          mid: mid,
          type: constants.MESSAGE_TYPE_TEXT,
          content: content,
          thread: this.userCurrentThread,
        };
      } else if (this.is_type_image(message)) {
        let msgObject = { type: message.type, content: message.imageUrl };
        let content =
          this.replyToContent + "REPLYTO:" + JSON.stringify(msgObject);
        payload = {
          mid: mid,
          type: constants.MESSAGE_TYPE_IMAGE,
          content: content,
          thread: this.userCurrentThread,
        };
      } else if (this.is_type_file(message)) {
        let msgObject = { type: message.type, content: message.fileUrl };
        let content =
          this.replyToContent + "REPLYTO:" + JSON.stringify(msgObject);
        payload = {
          mid: mid,
          type: constants.MESSAGE_TYPE_FILE,
          content: content,
          thread: this.userCurrentThread,
        };
      } else if (this.is_type_voice(message)) {
        let msgObject = { type: message.type, content: message.voiceUrl };
        let content =
          this.replyToContent + "REPLYTO:" + JSON.stringify(msgObject);
        payload = {
          mid: mid,
          type: constants.MESSAGE_TYPE_VOICE,
          content: content,
          thread: this.userCurrentThread,
        };
      } else if (this.is_type_video(message)) {
        let msgObject = {
          type: message.type,
          content: message.videoOrShortUrl,
        };
        let content =
          this.replyToContent + "REPLYTO:" + JSON.stringify(msgObject);
        payload = {
          mid: mid,
          type: constants.MESSAGE_TYPE_VIDEO,
          content: content,
          thread: this.userCurrentThread,
        };
      }
      this.sendMessageProtobuf(payload);
    },
    // 复制图片，支持jpg，png，传入图片url即可
    copyImageToClipboard(url) {
      // FIXME: 跨域问题，无法正常复制图片到剪贴板
      var canvas = document.createElement('canvas') // 创建一个画板
      let image = new Image()
      image.setAttribute("crossOrigin", 'anonymous') //可能会有跨越问题
      image.src = url
      image.onload = () => {  // img加载完成事件
          canvas.width = image.width  //设置画板宽度
          canvas.height = image.height //设置画板高度
          canvas.getContext('2d').drawImage(image, 0, 0); //加载img到画板
          let url = canvas.toDataURL("image/png") // 转换图片为dataURL，格式为png
          this.clipboardImg(url) // 调用复制方法
      }
    },
    // 从url下载并复制图片，如果是png格式的图片直接调用此方法就能复制成功
    async clipboardImg(url) {
        try {
            const data = await fetch(url);
            const blob = await data.blob();
            await navigator.clipboard.write([
                new window.ClipboardItem({
                    [blob.type]: blob
                })
            ]);
            this.$message({ message: '复制成功', type: 'success' })
        } catch (err) {
            this.$message.error('复制失败')
        }
    },
    // 下载图片保存
    downloadImage(imgsrc, name) {
      // if (this.electron) {
      //   ipcRenderer.send("save-image-dialog", imgsrc);
      //   return
      // }
      // FIXME: 跨域，无法正常下载。electron可以正常下载
      //下载图片地址和图片名
      // https://blog.csdn.net/wangbadandzy/article/details/113260245
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      // image.setAttribute("crossOrigin", "*");
      image.onload = function() {
        var canvas = document.createElement("canvas");
        canvas.width = image.width
        canvas.height = image.height
        var context = canvas.getContext("2d")
        context.drawImage(image, 0, 0, image.width, image.height)
        var dataUrl = canvas.toDataURL("image/png") //得到图片的base64编码数据
        var a = document.createElement("a") // 生成一个a元素
        a.target = "_blank"
        a.download = name || "default.png" // 设置图片名称
        a.href = dataUrl // 将生成的URL设置为a.href属性
        var event = new MouseEvent("click") // 创建一个单击事件
        a.dispatchEvent(event) // 触发a的单击事件
      };
      image.src = imgsrc
      // this.$message({ message: '下载成功', type: 'success' })
    },
  },
  mounted() {
    // 定时检测-消息是否超时发送失败
    this.timer = setInterval(this.checkTimeoutMessage, 2000);
    // 通知界面滚动到底部
    bus.$on(constants.EVENT_BUS_MESSAGE_SCROLL_TO_BOTTOM, () => {
      // console.log('scroll to bottom')
      let vm = this;
      vm.$nextTick(() => {
        const ul = vm.$refs.list;
        if (ul != null) {
          ul.scrollTop = ul.scrollHeight;
        }
      });
    });
    // 聊天记录加载完毕
    let app = this;
    bus.$on(constants.EVENT_BUS_MESSAGE_LOADED, () => {
      // console.log('message loaded')
      // if (app.loadingWidget) {
      //   app.loadingWidget.close()
      // }
      app.showLoading = false;
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  filters: {
    datetime(value) {
      if (typeof value === "string") {
        return moment(value).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return value;
      }
    },
  },
};
</script>

<style scoped>
.pullrefresh {
  margin-top: 20px;
  text-align: center;
  font-size: 10px;
  color: blue;
  cursor: pointer;
}
#bd-message {
  /* width: calc(100% - 20px); */
  /* height: calc(100% - 200px); */
  width: 100%;
  height: 100%;
  margin-left: 5px;
  margin-right: 5px;
  /* padding-left: 10px; */
  /* padding-bottom: 20px; */
  overflow-y: scroll;
}
.bd-message-ul {
  /* border: 1px solid #ccf; */
  font-size: 16px;
  height: 99%;
  /* margin: 0; */
  margin-left: 0px;
  margin-top: 0px;
  margin-bottom: 5px;
  /* padding-bottom: 10px; */
  overflow-y: auto;
  padding: 0;
}
li {
  margin-bottom: 15px;
  clear: both;
}
.main {
  margin-left: 0px;
}
.timestamp {
  margin: 10px 0;
  text-align: center;
  font-size: 10px;
}
.timestamp span {
  display: inline-block;
  padding: 0 8px;
  /* color: #fff; */
  border-radius: 5px;
  color: #bbbbbb;
}
.avatar {
  float: left;
  margin: 0 10px 0 0;
  border-radius: 3px;
}
.nickname {
  text-align: left;
  font-size: 10px;
}
.text {
  float: left;
  position: relative;
  padding: 2px 10px 0px;
  max-width: calc(100% - 250px);
  min-height: 30px;
  line-height: 2.5;
  font-size: 12px;
  text-align: left;
  word-break: break-all;
  background-color: #dddddd;
  border-radius: 4px;
  white-space: pre-line;
}
.text:before {
  content: " ";
  position: absolute;
  top: 9px;
  right: 100%;
  border: 6px solid transparent;
  border-right-color: #dddddd;
}
.self {
  text-align: right;
}
.self .avatar {
  float: right;
  margin: 0 5px 0 10px;
}
.self .nickname {
  text-align: right;
  font-size: 10px;
}
.self .text {
  float: right;
  background-color: #b2e281;
}
.self .text:before {
  right: inherit;
  left: 100%;
  border-right-color: transparent;
  border-left-color: #b2e281;
}
.self .status {
  float: right;
  margin-right: 8px;
}
.notification {
  text-align: center;
}
.chat li {
  border: none;
}
</style>
